import i18n from "@/lang";

const {
    t
} = i18n.global;

export default [{
        path: 'login',
        name: 'login',
        component: () => import('@views/auth/Login.vue'),
        meta: {
            requiresAuth: true,
            title: t('messages.login'),
        }
    },
    {
        path: "/login-loading",
        name: "login_loading",
        component: () => import('@views/auth/LoginLoading.vue'),
        meta: {
            requiresAuth: false,
            title: t("messages.login"),
        },
    },
    /* {
        path: '/forget-password',
        name: 'forget-password',
        component: () => import('@views/Auth/ForgetPassword')
    },
    {
        path: '/new-password',
        name: 'new-password',
        component: () => import('@views/Auth/NewPassword')
    }, */
]
